export const LOAD_FILES = 'dossier/LOAD_FILES';
export const CLEAR_FILES = 'dossier/CLEAR_FILES';